import { Expose } from "class-transformer";

export class CreateProjectHasFileDto {
  @Expose()
  projectId: string;

  @Expose()
  fileId: string;
}
